<div class="invoice-customer-delivery-selection-table">
  <div class="subtitle">{{ "invoice-customer-delivery-selection.subtitle" | translate }}<span> *</span></div>
  <div class="filters" *ngIf="filterer">
    <ui-dynamic-filters
      label="{{ 'invoice-customer-delivery-selection.datatable.filter-title' | translate }}"
      [filters]="filterer.getFilters()"
      [filterValues]="filterer.filterValues"
      (filterValuesChange)="filterValueChange($event)"
      (apply)="applyFilters()"
      [locale]="locale"
      dateFormat="{{ dateFormat }}"
      applyLabel="{{ 'invoice-customer-delivery-selection.datatable.filter-label' | translate }}"
      minLabel="{{ 'filters.min' | translate }}"
      maxLabel="{{ 'filters.max' | translate }}"
      deleteLabel="{{ 'filters.delete' | translate }}"
      placeholderPrefix="{{ 'filters.prefix' | translate }} "
      [btnIcon]="faSearch"
      btnType=""
    >
    </ui-dynamic-filters>
  </div>

  <div [formGroup]="tableControl" class="delivery-selection-table">
    <div>
      <ngx-datatable
        #table
        [rows]="rows"
        [trackByProp]="'id'"
        class="material"
        columnMode="flex"
        headerHeight="auto"
        footerHeight="50"
        rowHeight="40"
        [rowClass]="getRowClass"
        [cssClasses]="{
          sortAscending: 'fas fa-chevron-up',
          sortDescending: 'fas fa-chevron-down',
        }"
        [messages]="{ emptyMessage: 'global.no-data' | translate }"
        [externalSorting]="true"
        [externalPaging]="true"
        [count]="pager.totalElements"
        [offset]="pager.number"
        [limit]="pager.size"
        scrollbarH="true"
        [sorts]="sorts"
        (sort)="changeSortSettings($event.column.prop, $event.newValue)"
      >
        <ngx-datatable-column
          width="50"
          [sortable]="false"
          [draggable]="false"
          [resizeable]="false"
          [canAutoResize]="false"
          cellClass="center-align not-clickable"
        >
          <ng-template ngx-datatable-header-template>
            <div (click)="$event.stopPropagation()">
              <ui-checkbox
                customClass="no-margin"
                (change)="onHeaderCheckboxChange()"
                [formControlName]="'headerCheckbox'"
              >
              </ui-checkbox>
            </div>
          </ng-template>

          <ng-template ngx-datatable-cell-template let-id="row.id">
            <div class="adjust" (click)="$event.stopPropagation()">
              <ui-checkbox
                customClass="no-margin"
                (change)="onRowCheckboxChange()"
                [formControlName]="getRowControlName(id)"
              >
              </ui-checkbox>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.delivery-ref' | translate }}"
          prop="deliveryRef"
          cellClass="delivery-ref"
          [resizeable]="false"
          [flexGrow]="1"
        >
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.date' | translate }}"
          prop="date"
          cellClass="date"
          [resizeable]="false"
          [flexGrow]="1"
        >
          <ng-template ngx-datatable-cell-template let-date="row.date">
            <span *ngIf="date">{{ date | dateTimeFormat: false }}</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.delivery-type' | translate }}"
          prop="deliveryType"
          cellClass="delivery-type"
          [resizeable]="false"
          [flexGrow]="1"
        >
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.sender' | translate }}"
          prop="sender"
          cellClass="sender"
          [resizeable]="false"
          [flexGrow]="1"
        >
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.customer' | translate }}"
          prop="customer"
          cellClass="customer"
          [resizeable]="false"
          [flexGrow]="1"
          [sortable]="false"
        >
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.store' | translate }}"
          prop="store"
          cellClass="store"
          [resizeable]="false"
          [flexGrow]="1"
          [sortable]="false"
        >
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.qty-of-quantity' | translate }}"
          prop="totalQuantity"
          cellClass="total-quantity"
          [resizeable]="false"
          [flexGrow]="1"
          [canAutoResize]="true"
        >
          <ng-template ngx-datatable-cell-template let-uom="row.uom" let-value="value">
            <div class="adjust">
              <span>{{ value }}</span>
              <span class="{{ uom.class }}">&nbsp; {{ uom.name }}</span>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'invoice-customer-delivery-selection.datatable.columns.total-price' | translate }}"
          prop="totalPrice"
          cellClass="total-price"
          [resizeable]="false"
          [flexGrow]="1"
        >
          <ng-template ngx-datatable-cell-template let-currencyIsoCode="row.currencyIsoCode" let-value="value">
            <div class="adjust">
              {{ value | formatCurrency: currencyIsoCode : "symbol" : "0.2-2" : locale | async }}
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template
            ngx-datatable-footer-template
            let-rowCount="rowCount"
            let-pageSize="pageSize"
            let-selectedCount="selectedCount"
            let-curPage="curPage"
            let-offset="offset"
            let-isVisible="isVisible"
          >
            <div class="page-count">
              <span
                [innerHTML]="
                  selectedDeliveryForms.length === 0
                    ? ('global.datatable.no-items' | translate)
                    : (selectedDeliveryForms.length
                      | i18nPlural
                        : {
                            '=1': 'global.datatable.n-selected-items',
                            other: 'global.datatable.n-selected-items_plural',
                          }
                      | translate: { selectedElements: selectedDeliveryForms.length })
                "
              >
              </span>
            </div>
            <datatable-pager
              [pagerLeftArrowIcon]="'fas fa-chevron-left'"
              [pagerRightArrowIcon]="'fas fa-chevron-right'"
              [pagerNextIcon]="'fas fa-chevron-double-right'"
              [pagerPreviousIcon]="'fas fa-chevron-double-left'"
              [page]="curPage"
              [size]="pageSize"
              [count]="rowCount"
              [hidden]="!(rowCount / pageSize > 1)"
              (change)="changePage($event)"
            >
            </datatable-pager>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </div>
  </div>

  <div
    *ngIf="multipleStoreSelection && dfsAlreadySelected.length === 0"
    [formGroup]="formControl"
    class="delivery-selection-invoice-creation-type-checkbox"
  >
    <ui-checkbox
      customClass="no-margin"
      (change)="onOneInvoicePerStoreCheckboxChange()"
      [formControlName]="'oneInvoicePerStoreCheckbox'"
    >
    </ui-checkbox>
    <span>{{ "invoice-customer-delivery-selection.one-invoice-per-store-checkbox" | translate }}</span>
  </div>
</div>
